const MENU_TALENT = "Talent";
const MENU_COMPANIES = "Companies";
const MENU_DASHBOARD = "Dashboard";
const MENU_TABLE_MANAGEMENT = "Database";
const MENU_TALENT_MANAGEMENT = "TalentManagement";
const MENU_BOARD_MANAGEMENT = "BoardManagement";
const MENU_LINKEDIN_USERS = "LinkedinUsers";
const MENU_REPUTATION = "Reputation";
const MENU_HIRE_COMPANY = "HireCompanies";

const mainlinks = [
  {
    link: "/",
    text: MENU_DASHBOARD,
  },
  {
    link: "/talent/overview",
    text: MENU_TALENT,
  },
  {
    link: "/external_resumes/overview",
    text: "ExternalResumes",
  },
  {
    link: "/linkedin_users/overview",
    text: MENU_LINKEDIN_USERS,
  },
  {
    link: "/company/overview",
    text: MENU_COMPANIES,
  },
  {
    link: "/database",
    text: MENU_TABLE_MANAGEMENT,
  },
  {
    link: "/management",
    text: MENU_TALENT_MANAGEMENT,
  },
  {
    link: "/board",
    text: MENU_BOARD_MANAGEMENT,
  },
  {
    link: "/reputation",
    text: MENU_REPUTATION
  },
  {
    link: "/hire_company/overview",
    text: MENU_HIRE_COMPANY
  },

];

export const menu_data = {
  admin: {
    mainlinks: mainlinks,
  },
};
